import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { UserConfigurableModule } from '../../../types/User';
import { Account } from '../../../types/Account';
import { Event } from '../../../types/Event';
import { Task } from '../../../types/Task';
import { Contact } from '../../../types/Contact';
import { Employee } from '../../../types/Employee';

export interface SearchBase {
  uuid: string;
  url: string;
  display_name: string;
}

export type SearchResult =
  | (Account & SearchBase & { module: UserConfigurableModule.ACCOUNTS })
  | (Event & SearchBase & { module: UserConfigurableModule.EVENTS })
  | (Task & SearchBase & { module: UserConfigurableModule.TASKS })
  | (Contact & SearchBase & { module: UserConfigurableModule.CONTACTS })
  | (Employee & SearchBase & { module: UserConfigurableModule.EMPLOYEES });

export interface UseGlobalSearchParams {
  search?: string;
}

export const fetchGlobalSearch = async (params: UseGlobalSearchParams) => {
  if (!params.search?.trim()) return [];
  const response = await CustomAxios.get<SearchResult[]>('/search', { params });
  return response.data;
};

export function useGlobalSearch(params: UseGlobalSearchParams, enabled = true) {
  return useQuery({
    queryKey: [queryKeys.globalSearch, params.search],
    queryFn: () => fetchGlobalSearch(params),
    enabled: enabled && !!params.search?.trim(),
    placeholderData: keepPreviousData,
  });
}
